import { Tooltip } from '@octopus-do/octopus-storybook'
import type React from 'react'
import { forwardRef } from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'

interface Props extends React.PropsWithChildren {
  onClick: () => void
  label?: string
  active?: boolean
  className?: string
}

export const CommentHeaderButton = forwardRef<HTMLButtonElement, Props>(
  ({ onClick, label = '', active = false, children, className }, ref) => (
    <Tooltip label={label}>
      <button
        ref={ref}
        className={clsJoin(
          css.comment_header_button,
          active && css.active,
          className
        )}
        onClick={onClick}
      >
        {children}
      </button>
    </Tooltip>
  )
)
